<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-order-view" class="data-list-container">
		<vs-row class="mb-5">
			<vs-col vs-w="8" style="padding-right: 10px;">
				<div class="mb-4">
					<div class="mb-8 w-full ml-0" style="align-items: center;display: flex; flex-direction: row;width: 100%;overflow-x: scroll;">
						<div class="mr-2 ml-0" :key="`${upStatus}--1`" style="min-width: 100px;">
							<vs-button title="Tìm theo Sản phẩm phù hợp" class="font-bold w-full" :color="'#626262'" :type="isAll ? 'filled' : 'border'" @click="filterByStatus(-1)">Tất cả</vs-button>
						</div>
						<div class="mr-2" :key="`${upStatus}-${idxStatus}`" v-for="(statusLabel, idxStatus) in statusList">
							<vs-button title="Tìm theo Sản phẩm phù hợp" class="font-bold w-full" :color="statusLabel.color" :type="statusLabel.active ? 'filled' : 'border'" @click="filterByStatus(idxStatus)">{{statusLabel.name}}</vs-button>
						</div>
					</div>
					<div style="overflow-y: auto; height: 35vh;">
						<vs-table :noDataText="'Chưa có thông tin'" :sst="true" class="shadow-none border-none table-auto" stripe :data="$store.state.moduleProduct && $store.state.moduleProduct.myOrders" @sort="handleSort">
							
							<template slot="thead">
								<vs-th sort-key="id" style="min-width:80px;"><h6 class="uppercase font-bold">Mã</h6></vs-th>
								<vs-th sort-key="product_id" style="min-width:120px;"><h6 class="uppercase font-bold">Khách hàng</h6></vs-th>
								<vs-th sort-key="quantity" style="min-width:120px;"><h6 class="uppercase font-bold">Mặt hàng</h6></vs-th>
								<vs-th sort-key="quantity" style="min-width:80px;"><h6 class="uppercase font-bold">KL (kg)</h6></vs-th>
								<!-- <vs-th sort-key="price" style="min-width:100px;"><h6 class="uppercase font-bold">Tổng tiền</h6></vs-th> -->
								<vs-th sort-key="created_at" style="min-width:100px;"><h6 class="uppercase font-bold">Ngày nhận</h6></vs-th>
								<vs-th sort-key="updated_at" style="min-width:100px;"><h6 class="uppercase font-bold">Ngày xuất</h6></vs-th>
								<vs-th sort-key="status" style="min-width:140px;"><h6 class="uppercase font-bold">Trạng thái</h6></vs-th>
								<vs-th sort-key="" style="min-width:50px;"><h6 class="uppercase font-bold"></h6></vs-th>
							</template>

							<template slot-scope="{ data }">
								<vs-tr :key="indextr" v-for="(tr, indextr) in data" @click.native="handleClickItemRow($event, tr)" :set="statusDirective = $helper.getStatusAndDirectiveXuatHang(tr.status)">
									<vs-td>
										<p class="word-break uppercase" :style="{color: statusDirective.directive || '#626262'}">
											#{{ tr.id }}
										</p>
									</vs-td>
									<vs-td>
										<p class="word-break">
											{{ tr.creater ? tr.creater.name : '-' }}
										</p>
									</vs-td>
									<vs-td>
										<p class="word-break">
											{{ tr.details && tr.details.length ? (tr.details[0].product ? (tr.details[0].product.name) : '-') : '-' }}
											<sup style="cursor: help; color: rgb(210, 172, 36);position: absolute;" v-if="tr.details.length - 1 > 0">
											{{ ` +${tr.details.length - 1}sp` }}
											</sup>
										</p>
									</vs-td>
									<vs-td>
										<p :class="{ 'word-break': 1 }">
											{{ $helper.numFormat(tr.total_quantity) }}
										</p>
									</vs-td>
									<!-- <vs-td>
										<p :class="{ 'word-break': 1 }">
											{{ $helper.numFormat(tr.total) }}
										</p>
									</vs-td> -->
									<vs-td>
										<p class="word-break uppercase">
											{{ $helper.momentFormatLocale(tr.expected_date) }}
										</p>
									</vs-td>
									<vs-td>
										<p class="word-break uppercase">
											{{ tr.sell_date ? $helper.momentFormatLocale(tr.sell_date) : '-' }}
										</p>
									</vs-td>
									<vs-td>
										<p :class="{ 'word-break': 1 }">
											<label :class="statusDirective.directive">
												{{ statusDirective.name}}
											</label>
										</p>
									</vs-td>
									<vs-td >
										<div class="flex items-center justify-start">
											<!-- <div style="cursor: pointer; padding-left: 6px;" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" v-if="tr.status == 0">
												<i class="nucleo mr-1 text-danger nucleo-trash-can" />
												<span class="label text-danger">Từ chối</span>
											</div>
											<div style="cursor: pointer" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" v-if="tr.status == 0">
												<i class="nucleo mr-1 text-primary nucleo-drop" />
												<span class="label text-primary">Duyệt đơn</span>
											</div>
											
											<div style="cursor: pointer" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" v-if="tr.status == 1">
												<i class="nucleo mr-1 text-primary nucleo-e-add-2" />
												<span class="label text-primary">Tạo vận đơn</span>
											</div>

											<div style="cursor: pointer" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" v-if="tr.status == 5">
												<i class="nucleo mr-1 text-primary nucleo-drop" />
												<span class="label text-primary">Duyệt thanh toán</span>
											</div> -->

											<div style="cursor: pointer" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" v-if="tr.expected_date_changed">
												<i class="nucleo mr-1 text-warning nucleo-comment" />
												<span class="label text-warning">Đổi ngày</span>
											</div>
										</div>
									</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</div>
					<div class="w-full center mt-4">
						<CbsPagination :total="total" v-model="page"></CbsPagination>
					</div>
				</div>
				<div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-1 bs-box" style="height: 35vh">
					<div style="padding-right: 5px;" class="mobible-rm">
						<div class="b-box">
							<label style="color: #63BA46; font-weight: 900;">ĐƠN CHỜ DUYỆT MUA</label>
							<div style="height: 35vh; overflow-y: auto;">
								<vs-table :noDataText="'Chưa có thông tin'" :sst="true" class="mt-4" :data="dashboardBuys">
									
									<template slot="thead">
										<vs-th ><h6 class="font-bold">Khách hàng <br />&nbsp;</h6></vs-th>
										<vs-th ><h6 class="font-bold">Tổng lượng <br /> KG</h6></vs-th>
										<vs-th ><h6 class="font-bold">Tổng tiền <br /> VND</h6></vs-th>
									</template>

									<template slot-scope="{ data }">
										<vs-tr :key="indextr" v-for="(tr, indextr) in dashboardBuys" @click.native="handleClickItemRowNow($event, tr)">
											<vs-td>
												<p class="word-break">
													{{ tr.buyer_name }}
												</p>
											</vs-td>
											<vs-td>
												<p class="word-break">
													{{ $helper.numFormat(tr.quantity) }}
												</p>
											</vs-td>
											<vs-td>
												<p class="word-break">
													{{ $helper.numFormat(tr.price) }}
												</p>
											</vs-td>
										</vs-tr>
									</template>
								</vs-table>
							</div>
						</div>
					</div>
					<div style="padding-left: 5px;" class="mobible-rm">
						<div class="s-box">
							<label style="color: #057FBB; font-weight: 900;">CHỜ DUYỆT THANH TOÁN</label>
							<div style="height: 35vh; overflow-y: auto;">
								<vs-table :noDataText="'Chưa có thông tin'" :sst="true" class="mt-4" :data="dashboardSells">
									
									<template slot="thead">
										<vs-th ><h6 class="font-bold">Khách hàng <br />&nbsp;</h6></vs-th>
										<vs-th ><h6 class="font-bold">Tổng lượng <br /> KG</h6></vs-th>
										<vs-th ><h6 class="font-bold">Tổng tiền <br /> VND</h6></vs-th>
									</template>

									<template slot-scope="{ data }">
										<vs-tr :key="indextr" v-for="(tr, indextr) in dashboardSells" @click.native="handleClickItemRowNow($event, tr)">
											<vs-td>
												<p class="word-break">
													{{ tr.buyer_name }}
												</p>
											</vs-td>
											<vs-td>
												<p class="word-break">
													{{ $helper.numFormat(tr.quantity) }}
												</p>
											</vs-td>
											<vs-td>
												<p class="word-break">
													{{ $helper.numFormat(tr.price) }}
												</p>
											</vs-td>
										</vs-tr>
									</template>
								</vs-table>
							</div>
						</div>
					</div>
				</div>
			</vs-col>
			<vs-col vs-w="4">
				<div class="d-box" style="height: calc(70vh + 175px + 2rem); margin-bottom: 1.5rem; padding: 0;">
					<vue-cal xsmall active-view="day" :disable-views="['years', 'year', 'month']"
					:time-from="5 * 60"
					:time-to="22 * 60"
					:time-step="30"
					:events="events"
					:editable-events="{ title: false, drag: true, resize: true, delete: false, create: false }"
					:snap-to-time="15"
					:locale="'vi'"
					:on-event-click="onEventClick"
					@event-change="eventChange($event)"
					/>
				</div>
			</vs-col>
		</vs-row>

		<OrderFormNow :isPopupActive="orderFormNowDialog" @closePopup="toggleOrderNowSidebar" :data="orderFormNowData" />

		<OrderFormTa :isPopupActive="isDetailUserDialogActive" @closePopup="toggleDetailSidebar" :data="detailUserDialogData" />

	</div>
</template>

<script>
import CbsPagination from "@/components/cbs-pagination/CbsPagination";
import UserDetail from "./UserDetail.vue";
import OrderForm from "./OrderForm.vue";
import OrderFormNow from "./OrderFormNow.vue";
import OrderFormTa from "./OrderFormTa.vue";

import OrderDetail from "./OrderDetail.vue";
import KcsForm from "./KcsForm.vue";
import ChooseSells from "./ChooseSells.vue";
import SellerRatingForm from "./SellerRatingForm.vue";
import vSelect from "vue-select";
// import { GChart } from 'vue-google-charts/legacy';
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import 'vue-cal/dist/drag-and-drop.amd.js';
import moment from "moment";

const DATE_TYPE = {
	1: '7 NGÀY',
	2: '30 NGÀY',
	3: '90 NGÀY',
};

export default {
	components: {
		CbsPagination,
		UserDetail,
		OrderForm,
		OrderDetail,
		KcsForm,
		ChooseSells,
		SellerRatingForm,
		vSelect,
		// GChart,
		OrderFormNow,
		OrderFormTa,
		VueCal
	},
	data() {
		return {
			events: [
				{
				start: '2023-12-12 05:00',
				end: '2023-12-12 06:00',
				title: 'Need to go shopping',
				content: '<i class="icon material-icons">shopping_cart</i>',
				class: 'leisure',

				// icon: 'shopping_cart', // Custom attribute.
				// content: 'Click to see my shopping list',
				// contentFull: 'My shopping list is rather long:<br><ul><li>Avocados</li><li>Tomatoes</li><li>Potatoes</li><li>Mangoes</li></ul>', // Custom attribute.
				},
				{
				start: '2023-12-12 05:30',
				end: '2023-12-12 07:00',
				title: 'Golf with John',
				content: '<i class="icon material-icons">golf_course</i>',
				class: 'leisure'
				},
				{
				start: '2023-12-12 05:30',
				end: '2023-12-12 07:00',
				title: 'Golf with John',
				content: '<i class="icon material-icons">golf_course</i>',
				class: 'sport'
				},
			],
			matchedList: [],
			canBuy: true,
			canSell: true,
			chartData: [],
			chartOptions: {
				curveType: 'function',
				legend: { position: 'bottom' },
				width: 800,
				height: 600,
			},
			chartDateType: 1,
			overviewItem: {
				totalPrice: 0,
				totalOrder: 0,
				totalQuantity: 0,
			},
			overviewDateType: 2,
			currentProdSelected: null,
			product: null,
			prods: [],
			isAll: false,
			statusList: [
				{id: 0, name: 'Đang chờ', color: '#AF00CC', active: 0},
				{id: 2, name: 'Duyệt mua', color: '#63BA46', active: 0},
				{id: 4, name: 'Chờ TT', color: '#0E9F96', active: 0},
				{id: 5, name: 'Duyệt TT', color: '#057FBB', active: 0},
				{id: 6, name: 'Chờ xuất', color: '#D2AC24', active: 0},
				{id: 7, name: 'Hoàn thành', color: '#1DD100', active: 0},
			],
			orderFormNowDialog: false,
			orderFormNowData: {},
			sellerRatingDialog: false,
			sellerRatingData: {},
			shippingDialog: false,
			shippingData: {},
			listUser: [],
			page: 1,
			searchText: "",
			userDialog: false,
			userData: {},
			detailUserDialogData: null,
			isDetailUserDialogActive: false,
			isDetailUserCustomerDialogActive: false,
			customerDialog: false,
			filters: {
				// status: 2
			},
			canSelectSupplier: false,
			canBuy: false,
			canSell: false,
			customerData: {},
			userToken: '',
			sellsDialog: false,
			sellsData: {},
			upStatus: Date.now(),
			dashboardSells: [],
			dashboardBuys: [],
		};
	},
	computed: {
		total() {
			return Math.ceil(this.$store.state.moduleProduct.myOrdersTotal / this.$store.state.moduleProduct.limit);
		},
	},
	methods: {
		eventChange(changedEvent) {
			let {event} = changedEvent;
			if (event) {
				console.log(moment(event.start).format('YYYY-MM-DD HH:mm'), moment(event.end).format('YYYY-MM-DD HH:mm'));
				this.submitData(event.id, moment(event.start).format('YYYY-MM-DD HH:mm'), moment(event.end).format('YYYY-MM-DD HH:mm'));
			}
		},

		submitData(id, start, end) {
			try {
				const dataObj = {
					isPo: 1,
					isAdminChangedDate: 1,
					start: start,
					end: end,
					id: id
				};
				this.$store.dispatch("moduleProduct/createOrder", dataObj).then(response => {
					console.log('response: ', response);
					// this.$helper.notifySuccess({
					// 	context: this,
					// 	options: {
					// 		text: "Cập nhật thành công",
					// 		time: 3000,
					// 	},
					// });
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				
			}
		},
		onEventClick (event, e) {
			event.need_update = 1;
			this.detailUserDialogData = event
			this.isDetailUserDialogActive = true

			// Prevent navigating to narrower view (default vue-cal behavior).
			e.stopPropagation()
		},
		changeChartTypeTo(type) {
			this.chartDateType = type;
			this.getDashboardPriceHistories();
		},
		changeOverviewTypeTo(type) {
			this.overviewDateType = type;
			this.getOverviewOrder();
		},
		filterByStatus(idxStatus) {
			if (idxStatus == -1) {
				this.isAll = !this.isAll;
			} else {
				this.isAll = false;
			}
			this.statusList.map((status, index) => {
				// status.active = (index == idxStatus) ? !status.active : 0;
				if (this.isAll) {
					status.active = 0;
				}
				if (index == idxStatus) {
					status.active = !status.active;
				}
			});
			this.upStatus = Date.now();
			this.page = 1; // reset page
			this.getGetUsers();
		},
		printOrder(item) {
			console.log(item);
			// return;
            // var divContents = document.getElementById("test").innerHTML;
            var a = window.open(process.env.VUE_APP_GRAPHQL_DEFAULT_ENDPOINT+'/api/shipping-print/'+item.id+'?token='+this.userToken, '', 'height=800, width=800');
            // a.document.write('<html>');
            // a.document.write('<body > <h1>Div contents are <br>');
            // a.document.write(divContents);
            // a.document.write('</body></html>');
            // a.document.close();
			// a.focus();
            // a.print();

			// a.addEventListener('load', function() {
			// 	a.print();
			// 	a.close();
			// }, true);
        },
		onClickCancelOrder(id, event) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: 'Thực hiện hủy lệnh số #'+id,
				// accept: () => this.deleteCustomer(customer._id),
				accept: () => this.cancelOrder(id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
			if (event) {
				event.preventDefault()
			}
		},
		onClickEditOrder(data, event) {
			this.customerData = data;
			this.customerDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		onClickSellerRating(data, event) {
			let matchingId = 0;
			let cusName = '';
			if (data.type == 2) {
				matchingId = data.matching.id || '';
				cusName = data.matching.cus_name || '';
			} else {
				matchingId = data.matching_buy.id || '';
				cusName = data.matching_buy.supplier_name || '';
			}
			this.sellerRatingData = {
				type: data.type,
				id: data.id,
				matchId: matchingId,
				buyer_name: cusName,
				rating: data.rating,
				rating_note: data.rating_note
			};
			this.sellerRatingDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		onClickShippingOrder(data, event) {
			this.shippingData = {
				id: data.matching.id
			};
			this.shippingDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		onClickChooseSells(data, event) {
			this.sellsData = {
				id: data.id,
				status: data.status,
			};
			this.sellsDialog = true;
			if (event) {
				event.preventDefault()
			}
		},
		async cancelOrder(id) {
			this.$vs.loading();
			try {
				let payload = {
					id: id
				};
				await this.$store.dispatch("moduleProduct/cancelOrder", payload);
				this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		async getProducts() {
			const payload = {
			};
			try {
				this.$store.dispatch("moduleProduct/fetchProducts", payload).then(response => {
					console.log('fetchProducts: ', response);
					let dataProds = response.data || [];
					dataProds.sort(function(a, b) {
						var keyA = new Date(a.updated_at),
							keyB = new Date(b.updated_at);
						// Compare the 2 dates
						if (keyA < keyB) return 1;
						if (keyA > keyB) return -1;
						return 0;
					});
					this.product = dataProds.length ? dataProds[0].id : 0;
					this.prods = dataProds;
				});
			} catch (error) {
				console.log(error.message);
			}
		},
		async getGetUsers() {
			this.$vs.loading();
			let statuses = [];
			let isAll = false;
			this.statusList.map(status => {
				if (status.active) {
					if (status.id == -1) {
						isAll = true;
					}
					statuses.push(status.id);
				}
			});
			// console.log(this.statusList);
			this.filters.statuses = !isAll ? statuses : [];
			const payload = {
				filters: this.filters,
				id: 0,
				page: this.page,
				limit: this.$store.state.moduleProduct.limit,
				sort: this.sort,
				isPo: 1
			};
			try {
				await this.$store.dispatch("moduleProduct/getOrdersByMe", payload);
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		async getDashboardBuyList() {
			const payload = {isPo: 1, isUser: 0, id: 0, status: 0};
			try {
				let sells = await this.$store.dispatch("moduleProduct/getDashboardBuyList", payload);
				console.log('buys: ', sells);
				this.dashboardBuys = sells;
			} catch (error) {
				console.log(error.message);
			}
		},
		async getDashboardSellList() {
			const payload = {isPo: 1, isUser: 0, id: 0, status: 5};
			try {
				let sells = await this.$store.dispatch("moduleProduct/getDashboardBuyList", payload);
				console.log('sells: ', sells);
				this.dashboardSells = sells;
			} catch (error) {
				console.log(error.message);
			}
		},
		async getDashboardMatching() {
			const payload = {};
			try {
				let sells = await this.$store.dispatch("moduleProduct/getDashboardMatching", payload);
				console.log('getDashboardMatching: ', sells);
				this.matchedList = sells;
			} catch (error) {
				console.log(error.message);
			}
		},
		async getOverviewOrder() {
			const payload = {
				dateType: this.overviewDateType,
				isPo: 1,
				allData: 1,
				calendar: 1,
			};
			try {
				let overview = await this.$store.dispatch("moduleProduct/getOverviewOrder", payload);
				console.log('getOverviewOrder: ', overview);
				if (overview) {
					this.events = overview;
					// this.overviewItem.totalPrice = overview.total_price;
					// this.overviewItem.totalOrder = overview.total_order;
					// this.overviewItem.totalQuantity = overview.total_quantity;
				}
				this.dashboardSells = sells;
			} catch (error) {
				console.log(error.message);
			}
		},
		async getDashboardPriceHistories() {

			this.chartData = [];
			const payload = {
				id: this.currentProdSelected.id || 0,
				type: this.chartDateType
			};
			try {
				let sells = await this.$store.dispatch("moduleProduct/getDashboardPriceHistories", payload);
				if (sells.data && sells.data.length) {
					let chartDataTmp = [
						['Date', 'Price']
					];

					for (let k in sells.data) {
						let p = sells.data[k];
						if (p) {
							chartDataTmp.push([p.x, p.y]);
						}
					}

					console.log('chartDataTmp: ', chartDataTmp);
					this.chartData = chartDataTmp;
				}
			} catch (error) {
				console.log(error.message);
			}
		},
		handleSearch() {
			this.filters.fullname = this.searchText;
			this.getGetUsers();
		},
		openUserForm(user) {
			if (user) {
				this.editUser(user);
			} else {
				this.addNewUser();
			}
		},
		addNewUser() {
			this.userData = {};
			this.toggleUserDialog(true);
		},
		editUser(user) {
			// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
			this.userData = user;
			this.toggleUserDialog(true);
		},
	
		toggleShippingDialog(val = false) {
			this.shippingDialog = val;
		},
		toggleUserDialog(val = false) {
			this.userDialog = val;
		},
		toggleSellerRatingDialog(val = false) {
			this.sellerRatingDialog = val;
			if (!val) {
				this.customerData = {};
				this.getGetUsers();
			}
		},
		toggleSellsDialog(val = false) {
			this.sellsDialog = val;
			if (!val) {
				this.sellsData = {};
				this.getGetUsers();
			}
		},
		showDeleteUserConfirm(user) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteUser(user._id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel"),
			});
		},
		async deleteUser(userId) {
			this.$vs.loading();
			try {
				await this.$store.dispatch("moduleUser/removeRecord", userId);
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		handleOrderAction(type) {
			this.customerData.type = type;
			// this.customerData.product = this.detailUserDialogData;
			this.customerDialog = true;
		},
		handleClickItemRow(event, user) {
			const eventClasses = event.target && event.target.className;
			// show detail dialog if click target is not below classes
			if (event.target !== event.currentTarget && !eventClasses.split(" ").find((className) => ["cbs-context-menu", "cbs-color-picker", "item-relation--link"].includes(className))) {
				// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
				this.detailUserDialogData = user;
				this.toggleDetailSidebar(true);
			}
		},
		handleClickItemRowNow(event, user) {
			// const eventClasses = event.target && event.target.className;
			// // show detail dialog if click target is not below classes
			// if (event.target !== event.currentTarget && !eventClasses.split(" ").find((className) => ["cbs-context-menu", "cbs-color-picker", "item-relation--link"].includes(className))) {
			// 	// const _user = await this.$store.dispatch("moduleUser/fetchUser", user._id);
			// 	this.orderFormNowData = user;
			// 	this.toggleOrderNowSidebar(true);
			// }
			user.orderNow = 1;
			this.orderFormNowData = user;
			this.toggleOrderNowSidebar(true);
		},
		toggleOrderNowSidebar(val = false) {
			this.orderFormNowDialog = val;
		},
		toggleCustomerDialog(val = false) {
			this.customerDialog = val;
			if (!val) {
				this.customerData = {};
				this.getGetUsers();
			}
		},
		toggleDetailSidebar(val = false) {
			this.isDetailUserDialogActive = val;

			if (!val) {
				this.getGetUsers();
				this.getOverviewOrder();

				this.getDashboardSellList();
				this.getDashboardBuyList();
			}
		},
		toggleUserCustomerSidebar(val = false) {
			this.isDetailUserCustomerDialogActive = val;
		},
		handleSort(key, active) {
			const _key = key; // `_id.${key}`;
			this.sort = {};
			this.sort[_key] = active === "asc" ? 1 : -1;
			this.getGetUsers();
		},
		assignedZones(assignedZones) {
			// let _assignedZone = "";
			// Update property in user
			// assignedZones.map(assignedZone => {
			// 	_assignedZone = _assignedZone + (assignedZone.name + ", ");
			// });
			return assignedZones.reduce((zones, zone) => {
				zones += zone && zone.name ? `${zones ? ", " : ""}${zone.name}` : "";
				return zones;
			}, "");
			// _assignedZone = _assignedZone.slice(0, _assignedZone.lastIndexOf(","));
			// return _assignedZone;
		},
		showCustomerByUser(user) {
			this.detailUserCustomerDialogData = user;
			this.toggleUserCustomerSidebar(true);
		},
	},
	watch: {
		page() {
			this.getGetUsers();
		},
		searchText() {
			this.getGetUsers();
		},
		product() {
			console.log('this.product: ', this.product);
			this.currentProdSelected = this.prods.find(p => {
				return p.id == this.product;
			});
			this.getDashboardPriceHistories();
		}
	},
	mounted() {
		// console.log('this.$refs.overviewBox: ', this.$refs.overviewBox.clientWidth);
		// this.chartData = [
		// 		['Year', 'Sales'],
		// 		['2004', 1000],
		// 		['2005', 1170],
		// 		['2006', 660],
		// 		['2007', 1030],
		// 	];
		// this.chartOptions = {
		// 	title: '',
		// 	curveType: 'function',
		// 	legend: { position: 'none' },
		// 	width: this.$refs.overviewBox.clientWidth - 40,
		// 	height: 300,
		// 	chartArea: {
		// 		left: 40,
		// 		top: 20,
		// 		width: '90%',
		// 		height: '85%'
		// 	}
		// };
	},
	created() {
		// Register Module UserManagement Module
		this.getGetUsers();
		// this.getProducts();
		this.getDashboardSellList();
		this.getDashboardBuyList();
		this.getOverviewOrder();
		this.getDashboardMatching();

		if (typeof localStorage === 'object' && localStorage) {
			let forceRelogin = localStorage.getItem('relogin');
			if (!forceRelogin || parseInt(forceRelogin) < 1) {
				localStorage.removeItem("accessToken");
				this.$acl.change("guest");
				localStorage.removeItem("userInfo");
				this.$router.push("/pages/login").catch(() => {});
				window.location = '/';
			}
		}
	},
};
</script>

<style lang="scss">
.vuecal__event {cursor: pointer;}

// .vuecal__event-title {
//   font-size: 1.2em;
//   font-weight: bold;
//   margin: 4px 0 8px;
// }

// .vuecal__event-time {
//   display: inline-block;
//   margin-bottom: 12px;
//   padding-bottom: 12px;
//   border-bottom: 1px solid rgba(0, 0, 0, 0.2);
// }

// .vuecal__event-content {
//   font-style: italic;
// }

.vuecal__event.leisure {background-color: rgba(253, 156, 66, 0.9);border: 1px solid rgb(233, 136, 46);color: #fff;}
.vuecal__event.sport {background-color: rgba(255, 102, 102, 0.9);border: 1px solid rgb(235, 82, 82);color: #fff;}

.vuecal__event-content {
	display: flex;
    align-items: center;
    justify-content: center;
}
.vuecal__event.waiting {background-color: rgba(175, 0, 204, 0.9); border: 0.2px solid silver; color: #fff;}
.vuecal__event.shipping {background-color: rgba(210, 172, 36, 0.9); border: 0.2px solid silver; color: #fff;}
.vuecal__event.done {background-color: rgba(29, 209, 0, 0.9); border: 0.2px solid silver; color: #fff;}

.custom-nav-vertical {
	display: none !important;
	position: absolute !important;
	left: -1000px !important;
	top: -1000px !important;
}
.lbl-dbg {
	margin-top: 10px;
	margin-bottom: 10px;
	font-weight: 600;
	font-size: 12px;
	color: #000000;
}
.prod-price {
	font-weight: 500;
	font-size: 24px;
	color: #057FBB;
	padding-left: 10px;
}
.dash-select {
	margin-top: 10px;
}
.dash-select .vs__selected {
	font-weight: 600;
    font-size: 24px;
    color: #000000;
    margin-left: 0;
    padding-left: 0;
}
.dash-select .vs__dropdown-toggle {
	border: none !important;
}
.d-box {
	background: #FFFFFF;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
	border-radius: 5px;
	// min-height: 43.5vh;
	// max-height: 43.5vh;
	overflow-y: auto;
	padding: 22px;
	// margin-bottom: 25px;
}
.label-active {
	color: #030960 !important;
	text-decoration: underline !important;
}
.dash-label {
	font-weight: 700;
	font-size: 14px;
	line-height: 18px;
	/* identical to box height */


	// 
	color: rgba(0, 0, 0, 0.3);
}
.b-box {
	min-width: 35vh !important;
	padding: 23px;
	// margin-right: 10px;
	background: #FFFFFF;
	border: 2px solid #63BA46;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
	border-radius: 10px;
}
.s-box {
	min-width: 35vh !important;
	padding: 23px;
	// margin-left: 10px;
	background: #FFFFFF;
	border: 2px solid #057FBB;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
	border-radius: 10px;
}
.b-box .vs-con-tbody, .s-box .vs-con-tbody {
	border: none !important;
	background: transparent !important;
}

.btn-order-action {
	position: fixed !important;
	bottom: 20px;
	right: 10px;
	z-index: 9999;
}
#avatar-col {
	width: 10rem;
}

.vs-table--tbody-table {
	min-width: 300px !important;
}

#page-order-view {
	table {
		td:not(:first-child){
			vertical-align: top;
			// min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		// &:not(.permissions-table) {
		// 	td {
		// 		@media screen and (max-width: 370px) {
		// 			display: block;
		// 		}
		// 	}
		// }
	}
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px), only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}

	// #account-manage-buttons {
	//   width: 12rem !important;
	//   flex-direction: column;

	//   > button {
	//     margin-right: 0 !important;
	//     margin-bottom: 1rem;
	//   }
	// }
}
@media screen and (max-width: 991px) {
	.bs-box {
		height: auto !important;
		display: block !important;
	}
	.bs-box .mobible-rm {
		margin-right: 0 !important;
		margin-left: 0 !important;
		margin-bottom: 20px;
		padding: 0 !important;
	}
	#rmcs {
		grid-column: span 1 !important;
		grid-column-start: span 1 !important;
		grid-column-end: span 1 !important;
	}
	.pr-box {
		padding-left: 0 !important;
	}
	.btn-order-action {
		display: flex;
		right: 0 !important;
	}
}

.vs-button--text {
	white-space: nowrap !important;
}
</style>
